import GestaoVaga from "./GestaoVaga.jsx"

/** Rota legada /app/gestaoVaga/fila — mesma tela hub, aba «Fila de hoje». */
export default function GestaoVagaFila() {
	return <GestaoVaga entradaInicial="fab" />
}
